// 侧边选择页面顶部全选与查看已选 组件

<template>
  <div class="x3-side-select-base" v-if="show">
    <template>
      <div class="flex-center" @click.stop="clickAll">
        <van-icon v-if="isAll" name="checked" size="var(--fs-ex1)"  color="var(--c1)" />
        <van-icon v-else name="circle" size="var(--fs-ex1)" color="var(--g5)" />
        全选
      </div>
      <!-- <div class="check-desc" @click.stop="showSelect">已选:{{ ids.length }}</div> -->
      <div class="check-desc" @click.stop="showSelect">查看已选</div>
      <template>
        <van-action-sheet v-model="as1" :round="false" get-container="body">
          <div class="as1wrap">
            <div class="head">
              <div class="til">已选({{ list.length }})</div>
              <div class="clearbtn" @click="delAll">清空</div>
            </div>
            <div class="as1body">
              <template v-for="(seitem, index) in list">
                <slot :item="seitem" :index="index">
                  <div class="line van-hairline--bottom" :key="seitem[key_id]">
                    <div class="l">
                      <div class="name van-ellipsis">
                        <slot name="cont" :item="seitem" :index="index">
                          {{ seitem[key_txt] }}
                        </slot>
                      </div>
                    </div>
                    <div class="r">
                      <van-icon name="clear" color="var(--g6)" @click="del(index)" />
                    </div>
                  </div>
                </slot>
              </template>
            </div>
          </div>
        </van-action-sheet>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'isAll',
    event: 'change',
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    ids: {
      type: Array,
      default: [],
    },
    list: {
      type: Array,
      default: [],
    },
    key_txt: {
      type: String,
      default: 'name',
    },
    key_id: {
      type: String,
      default: 'id',
    },
    isAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      as1: false,
    };
  },
  computed: {},
  methods: {
    clickAll() {
      this.$emit('clickAllBtn');
    },
    // 查看已选
    showSelect() {
      if (this.ids.length > 0) {
        this.as1 = true;
      } else {
        vant.Toast('请至少先选择一项');
      }
    },
    // 清空全部已选
    delAll() {
      this.as1 = false;
      this.ids.splice(0);
      this.list.splice(0);
    },
    // 移除某个
    del(index) {
      this.ids.splice(index, 1);
      this.list.splice(index, 1);
      if (this.list.length == 0) {
        this.as1 = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.x3-side-select-base {
  flex-shrink: 0;
  white-space: nowrap;
  margin-right: calc(var(--gap) * 18);
  .flex-center {
    justify-content: flex-start;
  }
  .van-icon {
    margin-right: calc(var(--gap) * 8);
  }
  .check-desc {
    color: var(--tlc);
    margin-left: calc(var(--gap) * 26);
  }
}
.as1wrap {
  .head {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .clearbtn {
      position: absolute;
      right: calc(var(--gap) * 16);
      top: 50%;
      color: var(--tlc);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      padding: 6px;
      transform: translate3d(0, -50%, 0);
      margin-right: -6px;
    }
  }
  .as1body {
    min-height: 200px;
    max-height: 70vh;
    overflow: auto;
    .line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
      .l {
        overflow: hidden;
        .name {
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          color: var(--g8);
        }
        .desc {
          margin-top: calc(var(--gap) * 4);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          color: var(--g6);
        }
      }
      .r {
        line-height: 0;
        padding: 8px;
        margin-right: -8px;
      }
    }
  }
}
</style>